"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfiguratorState = exports.Util = exports.RawAR = exports.ModelAR = exports.SceneAR = exports.SceneProductAR = exports.ProductAR = exports.LauncherAR = exports.version = exports.PlattarQRCode = exports.PlattarWeb = void 0;
exports.PlattarWeb = __importStar(require("@plattar/plattar-web"));
exports.PlattarQRCode = __importStar(require("@plattar/plattar-qrcode"));
exports.version = __importStar(require("./version"));
var launcher_ar_1 = require("./ar/launcher-ar");
Object.defineProperty(exports, "LauncherAR", { enumerable: true, get: function () { return launcher_ar_1.LauncherAR; } });
var product_ar_1 = require("./ar/product-ar");
Object.defineProperty(exports, "ProductAR", { enumerable: true, get: function () { return product_ar_1.ProductAR; } });
var scene_product_ar_1 = require("./ar/scene-product-ar");
Object.defineProperty(exports, "SceneProductAR", { enumerable: true, get: function () { return scene_product_ar_1.SceneProductAR; } });
var scene_ar_1 = require("./ar/scene-ar");
Object.defineProperty(exports, "SceneAR", { enumerable: true, get: function () { return scene_ar_1.SceneAR; } });
var model_ar_1 = require("./ar/model-ar");
Object.defineProperty(exports, "ModelAR", { enumerable: true, get: function () { return model_ar_1.ModelAR; } });
var raw_ar_1 = require("./ar/raw-ar");
Object.defineProperty(exports, "RawAR", { enumerable: true, get: function () { return raw_ar_1.RawAR; } });
var util_1 = require("./util/util");
Object.defineProperty(exports, "Util", { enumerable: true, get: function () { return util_1.Util; } });
var configurator_state_1 = require("./util/configurator-state");
Object.defineProperty(exports, "ConfiguratorState", { enumerable: true, get: function () { return configurator_state_1.ConfiguratorState; } });
const plattar_embed_1 = __importDefault(require("./embed/plattar-embed"));
const version_1 = __importDefault(require("./version"));
if (customElements) {
    if (customElements.get("plattar-embed") === undefined) {
        customElements.define("plattar-embed", plattar_embed_1.default);
    }
}
console.log("using @plattar/plattar-ar-adapter v" + version_1.default);
